// extracted by mini-css-extract-plugin
export default {"whatsAppIcon":"WhatsAppButton_whatsAppIcon__2ltxu","globalWhatsappButton":"WhatsAppButton_globalWhatsappButton__oLKMq"};